import { useSelector } from 'react-redux';
import { hasUserPermissions } from '../../helpers/utils/permissoes';

export const PERMISSAO_GERENCIAR_DEVEDOR = 702;

/**
 * Gate de permissão do botão "Atualizar Cadastro" da aba Devedor (AW2-1134
 * Etapa 1) — mesma permissão já checada em produção (`DadosDevedor.jsx`,
 * `hasUserPermissions(702)`).
 *
 * Diferente do `useMemo(..., [])` de produção (nunca recalcula durante a
 * sessão), este hook depende explicitamente de
 * `state.authentication.userInformation.permissoes` — regra já documentada
 * em `src/prototipo/CLAUDE.md` ("`useMemo` que calcula RBAC por item deve
 * depender do dado real do Redux que `hasUserPermissions` lê, nunca de
 * `[]`") para não travar no snapshot da 1ª renderização caso a permissão do
 * usuário logado mude durante a sessão.
 *
 * Gate apenas cosmético — a autorização real é validada no backend de
 * `atualizarDadosDevedor`.
 */
export default function usePodeGerenciarDevedor() {
  // `hasUserPermissions` lê `store.getState()` diretamente (não aceita a
  // permissão como parâmetro) — a dependência abaixo só existe para forçar
  // este hook a recalcular quando a permissão do usuário logado mudar.
  useSelector(state => state.authentication.userInformation.permissoes);
  return hasUserPermissions(PERMISSAO_GERENCIAR_DEVEDOR);
}
